"use client";

import { Button } from "@/components/ui/Button";
import { useHintWindowPreference } from "@/hooks/useHintWindowPreference";
import type { HintWindowPreference } from "@/types";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";

type HintProps = {
  preference: HintWindowPreference;
  showArrow?: boolean;
  text: string;
};

export const Hint: React.FC<HintProps> = ({
  preference,
  showArrow = true,
  text,
}) => {
  const { isOpen: isVisible, setIsOpen: setIsVisible } =
    useHintWindowPreference(preference);

  if (!isVisible) return null;

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className="relative z-20">
      {/* Arrow */}
      {showArrow ? (
        <div className="absolute -top-2 right-10 size-4 rotate-45 border-l border-t border-border bg-background shadow-sm" />
      ) : null}

      {/* Card */}
      <div className="relative flex w-72 items-start gap-3 rounded-lg border border-border/70 bg-background p-4 text-sm text-foreground shadow-xl">
        <span className="absolute left-1 top-1 rounded-full bg-hover px-2 py-0.5 text-xs font-semibold text-foreground">
          TIP
        </span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={handleClose}
          className="absolute right-1 top-1 h-8 w-8 text-foreground hover:bg-hover hover:text-foreground"
          aria-label="Close hint"
        >
          <XMarkIcon className="size-4" aria-hidden="true" />
        </Button>

        <p className="flex-1 leading-relaxed break-words mt-2">{text}</p>
      </div>
    </div>
  );
};
